import { render } from "./App.vue?vue&type=template&id=3b62f87c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3b62f87c&lang=scss"
import "./App.vue?vue&type=style&index=1&id=3b62f87c&lang=css"
script.render = render

export default script